import { render } from "./GalleryLightComparison.vue?vue&type=template&id=134648c0&scoped=true"
import script from "./GalleryLightComparison.vue?vue&type=script&lang=js"
export * from "./GalleryLightComparison.vue?vue&type=script&lang=js"

import "./GalleryLightComparison.vue?vue&type=style&index=0&id=134648c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134648c0"]])

export default __exports__